import { render } from "./LineSeparator.vue?vue&type=template&id=0bb1ac17&scoped=true"
import script from "./LineSeparator.vue?vue&type=script&lang=js"
export * from "./LineSeparator.vue?vue&type=script&lang=js"

import "./LineSeparator.vue?vue&type=style&index=0&id=0bb1ac17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb1ac17"]])

export default __exports__